import { NavLink } from 'react-router-dom'
import Button from '@mui/material/Button';
import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import image from "../../Images/New Project.png"
// import MenuIcon from '@mui/icons-material/Menu';
import './NavBar.css'
const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(false)

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar)
  }
  return (
    <nav className="navbar">
      <div className="container">
        <div className="logo">
          <a href='/'>
           <h2 style={{cursor:"pointer"}}><span style={{color:"greenyellow"}}>SEO</span><span style={{paddingLeft:"3px",color:"white"}}>Mohrek</span>
           <img src={image} style={{width:"40px",height:"40px"}}></img></h2>
           </a>
        </div>
        <div className={`nav-elements  ${showNavbar && 'active'}`}>
          <ul>
          <li>
              <a target="_blank" href="https://mohrek.net">محرك</a>
            </li>
            <li>
              <NavLink to="/">الرئيسية</NavLink>
            </li>
          </ul>
        </div>
        <div>
          <div 
           className='buttonsRegister'
          style={{justifyContent:"space-between"}}>
         <Button variant="contained" style={{fontSize:"18px",backgroundColor:"#4eb54c"}}>تسجيل الدخول</Button>
         <Button variant="outlined" style={{marginLeft:"10px",color:"white",
         fontSize:"18px",width:"100px",borderColor:"#4eb54c"}}>تسجيل</Button>
         </div>
        </div>
        <div className="menu-icon" onClick={handleShowNavbar}>
           <MenuIcon style={{color:"white",fontSize:"40px"}} />
        </div>
      </div>
    </nav>
  )
}

export default Navbar;